import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
import { RouterModule, Routes } from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRadioModule} from '@angular/material/radio';
import {MatStepperModule} from '@angular/material/stepper';
import { EncuestadorComponent } from './encuestador.component';
import { LoginComponent } from './login/login.component';
import { SurveyComponent,DialogContentExampleDialog,DialogContentExampleDialogDefiniciones  } from './survey/survey.component';
import { NpsComponent } from './survey/nps/nps.component';
import { ReactivosComponent } from './survey/reactivos/reactivos.component';
import { AdicionalesComponent } from './survey/adicionales/adicionales.component';
import { AbiertasComponent } from './survey/abiertas/abiertas.component';
import { ControlComponent } from './survey/control/control.component';
import { DemograficosComponent } from './survey/demograficos/demograficos.component';
import { ForAllComponent } from './survey/for-all/for-all.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';

import { BarraProgresoComponent } from './survey/barra-progreso/barra-progreso.component';


const rutas: Routes = [
    {
        path     : 'appsurvey',
        component: EncuestadorComponent,
        children: [
          { path: '', redirectTo: 'login', pathMatch: 'full'  },
          { path: 'login', component: LoginComponent },
          { path: 'survey', component: SurveyComponent },
          // { path: 'languages', component: IdiomasComponent, canActivate: [AuthGuard] },
        ]
    },
];


@NgModule({
  declarations: [EncuestadorComponent, LoginComponent, SurveyComponent,NpsComponent,BarraProgresoComponent,ReactivosComponent, AdicionalesComponent,
  AbiertasComponent,ControlComponent,DemograficosComponent,ForAllComponent,DialogContentExampleDialog,DialogContentExampleDialogDefiniciones],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FuseSharedModule,
    FuseSidebarModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatRadioModule,
    MatStepperModule,
    MatDialogModule,
    MatDividerModule,
    TranslateModule,
    MatSelectModule
  ],
  entryComponents: [DialogContentExampleDialog,DialogContentExampleDialogDefiniciones],
})
export class EncuestadorModule { }
